import React from 'react';
import { IResponsivePictureProps, ResponsivePicture } from '../../../../ui';
import styled from '@emotion/styled';
import { IWeather } from '@move-frontend/dap';
import { FlightInfo } from './flight-info';
import { StyledFlightDetailHighlight } from './StyledFlightDetailHighlight';
import fallbackImage from '../../../../../assets/default-flight-detail.jpg';
import { IEnrichedFlight } from '../../shared/flight/domain/models/IEnrichedFlight';
import Responsive from '../../../../ui/utils/Responsive';

export const HighlightImage = styled(
	ResponsivePicture,
)<IResponsivePictureProps>`
	min-width: 45%;
	flex: 1 0 45%;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		display: none;
	}
`;

const FlightInfoWrap = styled.div`
	min-width: 55%;
	flex: 1 0 55%;

	p:last-of-type {
		margin-bottom: 0;
	}
`;

interface IFlightDetailHighlightProps {
	flight: IEnrichedFlight;
	weather?: IWeather;
	highlightImage?: string;
}

export const FlightDetailHighlight = ({
	flight,
	weather,
	highlightImage,
}: IFlightDetailHighlightProps) => (
	<StyledFlightDetailHighlight>
		<FlightInfoWrap>
			<FlightInfo flight={flight} weather={weather} />
		</FlightInfoWrap>

		<HighlightImage source={highlightImage || fallbackImage} alt="" />
	</StyledFlightDetailHighlight>
);
